import angular from "angular";

angular
    .module('app')
    .component('videoCard', {
        template: require('./video-card.html'),
        controller: ['$uibModal', controller],
        bindings: {
            video: '<'
        }
    });

function controller($uibModal) {

    let $ctrl = this;

    $ctrl.isActive = false;

    $ctrl.openVideoModal = function () {
        $uibModal.open({
            component: 'videoModalPlayer',
            resolve: {
                video: function () {
                    return $ctrl.video;
                }
            },
            size: 'lg'
        });
    };

}
